import React from 'react'

import NavButton from './navButton'
import IconPrev from '../../icons/chevronLeft'

import styles from './buttons.module.css'

const PrevButton = ({ item }) => (
  <NavButton keyName="ArrowLeft" item={item}>
    <IconPrev className={styles.iconPrev} />
  </NavButton>
)

export default PrevButton
